export const ADD_HOLIDAY = 'ADD_HOLIDAY'
export const DELETE_HOLIDAY = 'DELETE_HOLIDAY'
export const UPDATE_HOLIDAY_FIELD = 'UPDATE_HOLIDAY_FIELD'
export const RESET_HOLIDAYS = 'RESET_HOLIDAYS'
export const SAVE_HOLIDAYS = 'UPDATE_HOLIDAYS'
export const UPDATE_HOLIDAYS = 'UPDATE_HOLIDAYS'
export const SORT_HOLIDAYS = 'SORT_HOLIDAYS'



// WEBPACK FOOTER //
// ./src/pages/schedules/holidays/constants.ts